import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { 
  PlayArrow as PlayArrowIcon, 
  Edit as EditIcon, 
  Delete as DeleteIcon, 
  Pause as PauseIcon,
  Replay as ReplayIcon, 
} from '@mui/icons-material';

const JobActions = ({ job, onEdit, onRunNow, onToggleStatus, onDelete }) => (
  <Box sx={{ display: 'flex', gap: 1 }}>
    {/* <Tooltip title="Run Now">
      <IconButton size="small" onClick={() => onRunNow(job.jobDefinitionId)}>
        <PlayArrowIcon />
      </IconButton>
    </Tooltip> */}
    <Tooltip title="Edit">
      <IconButton size="small" onClick={() => onEdit(job.jobDefinitionId)}>
        <EditIcon />
      </IconButton>
    </Tooltip>
    <Tooltip title={job.status === 'ACTIVE' ? 'Pause' : 'Resume'}>
      <IconButton size="small" onClick={() => onToggleStatus(job.jobDefinitionId)}>
        {job.status === 'ACTIVE' ? <PauseIcon /> : <ReplayIcon />}
      </IconButton>
    </Tooltip>
    <Tooltip title="Delete">
      <IconButton size="small" onClick={() => onDelete(job.jobDefinitionId)}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  </Box>
);

export default JobActions;
